import { addFilter_log } from "../log";

export function filter_ALL(){
	if (window.location.pathname.includes("/tripPlanner") || window.location.pathname.includes("/tripPlanner")) {
		let instantBookEnabled:boolean = $("#instantBook").hasClass("active");
		filter_instantBook_campsTP(instantBookEnabled);
	};

	let amenity_filter_list:Array<string> = [];
	$(".amenityToggleButton.active").each(function() {
		amenity_filter_list.push($(this).attr("id").toString());
	});
	for (let i:number=0; i < amenity_filter_list.length; i++) {
		filter_aANDa("amenity", amenity_filter_list[i], "add");
	};

	let activity_filter_list:Array<string> = [];
	$(".activityToggleButton.active").each(function() {
		activity_filter_list.push($(this).attr("id").toString());
	});
	for (let i:number=0; i < activity_filter_list.length; i++) {
		filter_aANDa("activity", activity_filter_list[i], "add");
	};

	let min_genieScore:number = parseInt($(".range-slider-value-min[campRatingFilter]").val() as string);
	let max_genieScore:number = parseInt($(".range-slider-value-max[campRatingFilter]").val() as string);
	filter_by_rating(min_genieScore,max_genieScore);

	let inputMin:number = parseInt($("#sites_min").val().toString());
	let inputMax:number = parseInt($("#sites_max").val().toString());
	filter_by_sites();

	let lenMin:number = parseInt($("#rvL_min").val().toString());
	let lenMax:number = parseInt($("#rvL_max").val().toString());
	let widMin:number = parseInt($("#rvW_min").val().toString());
	let widMax:number = parseInt($("#rvW_max").val().toString());
	filter_by_rvLW({len_min:lenMin,len_max:lenMax,wid_min:widMin,wid_max:widMax});

	let inputMinP:number = parseInt($("#price_min").val().toString());
	let inputMaxP:number = parseInt($("#price_max").val().toString());
	filter_by_price({val_min:inputMinP,val_max:inputMaxP});

	//Deal with discount and affiliate filtering
	//HARDCODED :O, make sure the arrays below match with RVtrippy_partials/filters/dANDaFILTERS.pug, main.ts, and index_scipts.ts
	let discounts: string[] = ["Military Veteran", "Good Sam Club", "Senior Citizen", "AAA Member"];
	//Iterate through and make the array match the ID's in pug
	discounts = discounts.map((discount) => {
		return discount.toLowerCase().replace(/\s+/g, '_');
	});
	let affiliates: string[] = ["KOA", "Sun Outdoors", "COE", "NPS", "NFA", "State Park"];
	//Iterate through and make the array match the ID's in pug
	affiliates = affiliates.map((affiliate) => {
		return affiliate.toLowerCase().replace(/\s+/g, '_');
	});

	discounts.forEach((id) => {
		if($("#" + id).hasClass("active")){
			filter_by_discounts("#" + id, discounts, $("#" + id).hasClass("active"));
		}
	});

	affiliates.forEach((id) => {
		if($("#" + id).hasClass("active")){
			filter_by_affiliates("#" + id, affiliates, $("#" + id).hasClass("active"));
		}
	});

	$(".campsite-card").each(function() {
		if(isFiltered($(this))){
			if(!$(this).hasClass("d-none")) $(this).addClass("d-none");
		}
	});
};

export function sort_camp_card_list(camp_card_wrapper:JQuery<HTMLElement>,sortBy:string) {
	let camp_cards:HTMLElement[] = camp_card_wrapper.find(".campsite-card").toArray();
	switch(sortBy) {
		case "genie_score":
			camp_cards.sort(function(a,b) {
				if ($(a).find('.campsite-rating').length) {
					var scoreA:number = parseInt($(a).find('.campsite-rating').html());
				} else {
					var scoreA:number = 0
				};
				if ($(b).find('.campsite-rating').length) {
					var scoreB:number = parseInt($(b).find(".campsite-rating").html());
				} else {
					var scoreB:number = 0;
				};
				if (Number.isNaN(scoreA)) scoreA = 0;
				if (Number.isNaN(scoreB)) scoreB = 0;

				return scoreB - scoreA;
			});
			break;
		case "genie_match":
			camp_cards.sort(function(a,b) {
				if ($(a).find('.campsite-match').length) {
					var scoreA:number = parseInt($(a).find('.campsite-match').html());
				} else {
					var scoreA:number = 0;
				};
				if ($(b).find('.campsite-match').length) {
					var scoreB:number = parseInt($(b).find(".campsite-match").html());
				} else {
					var scoreB = 0;
				};
				if (Number.isNaN(scoreA)) scoreA = 0;
				if (Number.isNaN(scoreB)) scoreB = 0;

				return scoreB - scoreA;
			});
			break;
		case "name":
			camp_cards.sort(function(a,b) {
				if ($(a).find('[campsite_name]').length) {
					var nameA = $(a).find('[campsite_name]').html().trim();
				} else {
					return 1
				};
				if ($(b).find('[campsite_name]').length) {
					var nameB = $(b).find('[campsite_name]').html().trim();
				} else {
					return -1;
				};
				return nameA.localeCompare(nameB);
			});
			break;
		case "name_reverse":
			camp_cards.sort(function(a,b) {
				if ($(a).find('[campsite_name]').length) {
					var nameA = $(a).find('[campsite_name]').html().trim();
				} else {
					return 1
				};
				if ($(b).find('[campsite_name]').length) {
					var nameB = $(b).find('[campsite_name]').html().trim();
				} else {
					return -1;
				};
				return nameB.localeCompare(nameA);
			});
			break;
		case "dist_to_stop":
			camp_cards.sort(function(a,b) {
				if ($(a).find('[distToStop]').length) {
					var scoreA:number = parseInt($(a).find('[distToStop]').html().replace(/[^0-9.]/g,""));
				} else {
					var scoreA:number = 0
				};
				if ($(b).find('[distToStop]').length) {
					var scoreB:number = parseInt($(b).find('[distToStop]').html().replace(/[^0-9.]/g,""));
				} else {
					var scoreB:number = 0;
				};
				if (Number.isNaN(scoreA)) scoreA = 0;
				if (Number.isNaN(scoreB)) scoreB = 0;

				return scoreA - scoreB;
			});
			break;
		case "dist_to_stop_reverse":
			camp_cards.sort(function(a,b) {
				if ($(a).find('[distToStop]').length) {
					var scoreA:number = parseInt($(a).find('[distToStop]').html().replace(/[^0-9.]/g,""));
				} else {
					var scoreA:number = 0
				};
				if ($(b).find('[distToStop]').length) {
					var scoreB:number = parseInt($(b).find('[distToStop]').html().replace(/[^0-9.]/g,""));
				} else {
					var scoreB:number = 0;
				};
				if (Number.isNaN(scoreA)) scoreA = 0;
				if (Number.isNaN(scoreB)) scoreB = 0;

				return scoreB - scoreA;
			});
			break;
		case "price":
			camp_cards.sort(function(a,b) {
				let scoreA:number,scoreB:number;
				if ($(a).find(".campgrounds-price").length) {
					var p_low:string = $(a).find(".campgrounds-price").html().split(",")[0];
					if (p_low != "?" && p_low != "None") {
						scoreA = parseFloat(p_low);
					} else {
						scoreA = Infinity
					};
				} else {
					scoreA = Infinity
				};
				if ($(b).find(".campgrounds-price").length) {
					var p_low:string = $(b).find(".campgrounds-price").html().split(",")[0];
					if (p_low != "?" && p_low != "None") {
						scoreB = parseFloat(p_low);
					} else {
						scoreB = Infinity
					};
				} else {
					scoreB = Infinity
				};
				return scoreA - scoreB;
			});
			break;
		case "price_reverse":
			camp_cards.sort(function(a,b) {
				let scoreA:number,scoreB:number;
				if ($(a).find(".campgrounds-price").length) {
					var p_low:string = $(a).find(".campgrounds-price").html().split(",")[0];
					if (p_low != "?" && p_low != "None") {
						scoreA = parseFloat(p_low);
					} else {
						scoreA = -Infinity
					};
				} else {
					scoreA = -Infinity
				};
				if ($(b).find(".campgrounds-price").length) {
					var p_low:string = $(b).find(".campgrounds-price").html().split(",")[0];
					if (p_low != "?" && p_low != "None") {
						scoreB = parseFloat(p_low);
					} else {
						scoreB = -Infinity
					};
				} else {
					scoreB = -Infinity
				};
				return scoreB - scoreA;
			});
			break;
		default:
			break;
	};
	camp_card_wrapper.empty();
	camp_cards.forEach(function(el) {
		camp_card_wrapper.append(el);
	});
};

//checks if input amenity is in input camp_card's child element with class 'amenity-list'
function check_camp_amenity(camp_card: HTMLElement, amenity: string): boolean {
	let has_amenity: boolean = false;
	$.each($(camp_card).find(".amenity-list"),function() {
		if ($(this).html().includes(amenity)) {
			has_amenity = true;
			return false;
		};
	});
	return has_amenity;
};
function check_camp_activity(camp_card: HTMLElement, activity: string): boolean {
	let has_activity: boolean = false;
	$.each($(camp_card).find(".activity-list"),function() {
		if ($(this).html().includes(activity)) {
			has_activity = true;
			return false;
		};
	});
	return has_activity;
};

/*
 * OUTDATED 1/16/23
 * iterates through amenities
 *   for each amenity, iterates through campsite-cards & find number that are currently displayed
 *     - if campsite-card does not have class !amenity or class !rating then it's displayed
 *   updates display next to amenity for # camps currently matching filter
 */
export function updateFilterCountDisp() {
	$(".amenity-filter").each(function() {
		let amenity:string = $(this).attr("id").toString();
		let count:number = 0;
		$(".campsite-card").each(function() {
			if ($(this).hasClass("!amenity") || $(this).hasClass("!rating")) return;
			if (check_camp_amenity(this, amenity)) {
				count += 1;
			};
		});
		if (count == 0) $(`#n-${amenity}`).html(" (0)");
		else $(`#n-${amenity}`).html(" (" + count.toString() + ")");
	});
};

//Goes through each amenity and activity button and updates the display number with the appropriate number of visible activity/amenities
export function update_aANDa_display(){

	$(".amenityToggleButton").each(function(){
		let amenity:string = $(this).attr("id").toString();
		let count:number = 0;
		$(".campsite-card").each(function() {
			if ($(this).attr("unfilterable") != undefined) {
				return;
			};
			if ($(this).hasClass("!amenity") || $(this).hasClass("!rating")) return;
			if (check_camp_amenity(this, amenity) && !($(this).hasClass("d-none"))) {
				count += 1;
			};
		});
		if (count == 0) $(`#n-${amenity}`).html(" (0)");
		else $(`#n-${amenity}`).html(" (" + count.toString() + ")");
	});
	$(".activityToggleButton").each(function(){
		let activity:string = $(this).attr("id").toString();
		let count:number = 0;
		$(".campsite-card").each(function() {
			if ($(this).attr("unfilterable") != undefined) {
				return;
			};
			if ($(this).hasClass("!activity") || $(this).hasClass("!rating")) return;
			if (check_camp_activity(this, activity) && !($(this).hasClass("d-none"))) {
				count += 1;
			};
		});
		if (count == 0) $(`#n-${activity}`).html(" (0)");
		else $(`#n-${activity}`).html(" (" + count.toString() + ")");
	});
};

/*
 * OUTDATED 1/16/23
 * case action="add":
 *   - goes through each campsite-card - if camp does not have amenity:
 * 		 adds !amenity class as well as !<param amentiy> class & hides campsite-card
 * case action="rem":
 *   - goes through each campsite-card - if camp has !<param amenity> class
 * 		-removes class
 * 		-checks campsite-card doesn't have any other ! classes for other amenities
 * 			- if it doesn't, removes !amenity class to indicate camp matches all current amenity filters
 * 		-if removed !amenity class, checks campsite-card doesn't have !rating (meaning doesn't match rating filter)
 * 			- if campsite-card doesn't ahve !rating or !amenity anymore & was previously hidden, shows campsite-card
*/
export function filter_by_amenity(amenity: string, action: string) {
	switch(action) {
		case "add":
			$(".campsite-card").each(function() {
				if ($(this).attr("unfilterable") != undefined) {
					return;
				};
				if (!check_camp_amenity(this, amenity)) {
					$(this).addClass("!amenity !" + amenity);
					if (!$(this).hasClass("d-none")) $(this).addClass("d-none");
				};
			});
			update_aANDa_display();
			break;
		case "rem":
			$(".campsite-card").each(function () {
				let has_other_filter = false;
				if (!check_camp_amenity(this, amenity) && !$(this).hasClass("!rating")) {
					if ($(this).hasClass("!amenity")) {
						let $classlist = $(this).attr("class").split(/\s+/);
						$.each($classlist, function() {
							if (!this.includes("!") || this == '!amenity' || this == "!rating") return true;/* continue */
							if (this.replace("!","") != amenity) {
								has_other_filter = true;
								return false;
							};
							return true;/* continue */
						});
					};
					if (!has_other_filter) {
						if (!$(this).hasClass("!rating")) $(this).removeClass("d-none !amenity ");
						else $(this).removeClass("!amenity");
					};
					$(this).removeClass("!" + amenity);
				};
			});
			update_aANDa_display();
			break;
		default:
			break;
	};

	if ($(".campsite-card:not(.\\!amenity,.\\!rating)").length == 0) {
		$(document).scrollTop(0);
	};
};


//THE NEW filtering function. Takes in 3 variables...
//aORa = "activity" or "amenity"
//aORa_ID = the html elements id of the activity or amenity button
//action = "add" or "rem" which will add or remove the campsties with said amenity/activity from the campground search results
export function filter_aANDa(aORa: "amenity"|"activity", aORa_ID: string, action: string){
	let allAmenities = $("#allAmenity").html();
	let allActivity = $("#allActivity").html();

	update_aANDa_display();
	if(action === "add"){
		addFilter_log(aORa, aORa_ID);
		$(".campsite-card").each(function() {
			if ($(this).attr("unfilterable") != undefined) {
				return;
			};
			if(aORa === "amenity"){
				if (!check_camp_amenity(this, aORa_ID)) {
					$(this).addClass("!amenity !" + aORa_ID);
					if (!$(this).hasClass("d-none")) $(this).addClass("d-none");
				};
			}else if(aORa === "activity"){
				if (!check_camp_activity(this, aORa_ID)) {
					$(this).addClass("!activity !" + aORa_ID);
					if (!$(this).hasClass("d-none")) $(this).addClass("d-none");
				};
			}
		});
		update_aANDa_display();
	}else if(action === "rem"){
		$(".campsite-card").each(function () {
			let has_other_filter = false;
			if(aORa === "amenity"){
				if (!check_camp_amenity(this, aORa_ID)) {
					if ($(this).hasClass("!amenity")) {
						let $classlist = $(this).attr("class").split(/\s+/);
						$.each($classlist, function() {
							if (!this.includes("!") || this == '!amenity' || this == "!rating" || this == "!activity" || this == "!sites") return true;/* continue */
							if (allAmenities.includes(this.replace("!","")) && this.replace("!","") != aORa_ID) {
								has_other_filter = true;
								return false;
							};
							return true;/* continue */
						});
					};
					if (!has_other_filter) {
						$(this).removeClass("!amenity");
						if (!isFiltered($(this))) $(this).removeClass("d-none");
					};
					$(this).removeClass("!" + aORa_ID);
				};
			}else if(aORa === "activity"){
				if (!check_camp_activity(this, aORa_ID)) {
					if ($(this).hasClass("!activity")) {
						let $classlist = $(this).attr("class").split(/\s+/);
						$.each($classlist, function() {
							if (!this.includes("!") || this == '!activity' || this == "!rating" || this == "!amenity" || this == "!sites") return true;/* continue */
							if (allActivity.includes(this.replace("!","")) && this.replace("!","") != aORa_ID) {
								has_other_filter = true;
								return false;
							};
							return true;/* continue */
						});
					};
					if (!has_other_filter) {
						$(this).removeClass("!activity");
						if (!isFiltered($(this))) $(this).removeClass("d-none");
					};
					$(this).removeClass("!" + aORa_ID);
				};
			};
		});
		update_aANDa_display();
	};
};

/*
 * iterates through campsite-cards checking genie_score value is between input filters
 *   - if not, adds class !rating
 *   	- if campsite-card currently displayed, hides it
 *   - if it does
 * 		- removes class !rating if campsite-card has it
 * 		- if camp hidden & doesn't have !amenity class, shows campsite-card
 */
export function filter_by_rating(val_min: number, val_max: number) {
	$(".campsite-card").each(function() {
		if ($(this).attr("unfilterable") != undefined) {
			return;
		};
		if ($(this).find(".campsite-rating").length == 0) {
			if (val_min > 0) {
				if (!$(this).hasClass("!rating")) $(this).addClass("!rating");
				if (!$(this).hasClass("d-none")) $(this).addClass("d-none");
			} else {
				if ($(this).hasClass("!rating")) $(this).removeClass("!rating");
				if ($(this).hasClass("d-none") && !isFiltered($(this))) {
					$(this).removeClass("d-none");
				};
			};
			return;
		};
		let rating_str:string = $(this).find(".campsite-rating").html();
		if (rating_str == undefined)return;
		let rating:number = parseInt(rating_str);

		if (isNaN(rating) && (val_min > 0 || val_max < 100)) {
			if (!$(this).hasClass("d-none")) $(this).addClass("d-none");
		} else if (val_min == 0 && val_max == 100 && $(this).hasClass("d-none")) {
			$(this).removeClass("d-none");
		};

		if (rating < val_min || rating > val_max) {
			$(this).addClass("!rating");
			if (!$(this).hasClass("d-none")) $(this).addClass("d-none");
		} else if ($(this).hasClass("!rating")) {
			$(this).removeClass("!rating");
			if ($(this).hasClass("d-none") && !isFiltered($(this))) $(this).removeClass("d-none");
		};
	});
	update_aANDa_display();
};

export function setup_filter_listeners(): void{
	//
	//FILTERING (other than amenity/activity shtuff)
	//
	$("#price_min").before("<p style='margin-top:1.6rem;opacity:.5;' class='position-absolute ms-2'>$</p>");
	$("#price_max").before("<p style='margin-top:1.6rem;opacity:.5;' class='position-absolute ms-2'>$</p>");


};


//function that returns whether an element is "being filtered" by one of the various filter options
export function isFiltered(element: JQuery<HTMLElement>): boolean {
	const classes = ['!amenity', '!activity', '!sites', '!rating', '!price', '!rvLW', '!discount', '!affiliate','!instantBook'];
  for (const className of classes) {
    if (element.hasClass(className)) {
      return true;
    }
  }
  return false;
};

//Difference between filter by affiliates/discounts other than variable names is that affiliate filters are treated as ORs instead of ANDs
export function filter_by_affiliates(id:string, affiliates:string[], isActive:boolean){
	let allAffiliatesActive:string[] = [];
	$(".affiliateButton.active").each(function(this:HTMLElement){
		allAffiliatesActive.push($(this).attr("id"));
	});
	if(isActive && !allAffiliatesActive.includes(id.replace("#",""))) allAffiliatesActive.push(id.replace("#",""));
	if(!isActive){
		allAffiliatesActive = allAffiliatesActive.filter((value) => {
			return value !== id.replace("#","");
		});
	}

	$(".campsite-card").each(function() {
		if ($(this).attr("unfilterable") != undefined) {
			return;
		};
		//get data from card
		let campAffiliates:string[] = JSON.parse($(this).find(".affiliates").text().replace(/'/g, '"'));

		// Check if at least one element in allAffiliatesActive is in campAffiliates
		let foundMatch = false;
		$.each(allAffiliatesActive, function(index, value:string) {
			if (campAffiliates.includes(value)) {
				foundMatch = true;
				return false; // exit the loop early if a match is found
			}
		});
		if(foundMatch || allAffiliatesActive.length == 0){
			if($(this).hasClass("!affiliate")) $(this).removeClass("!affiliate");
			if($(this).hasClass("d-none") && !isFiltered($(this))){
				$(this).removeClass("d-none");
			}
		}else{
			if(!$(this).hasClass("!affiliate")) $(this).addClass("!affiliate");
			if(!$(this).hasClass("d-none")) $(this).addClass("d-none");
		}

	});
	update_aANDa_display();
};

export function filter_by_discounts(id:string, discounts:string[], isActive:boolean){
	$(".campsite-card").each(function() {
		if ($(this).attr("unfilterable") != undefined) {
			return;
		};
		//get data from card
		let campDiscounts:string[] = JSON.parse($(this).find(".discounts").text().replace(/'/g, '"'));
		//if the card does not contains the filtered id
		if(!campDiscounts.includes(id.replace("#","")) && isActive){
			//Adds appropriate flags
			if(!$(this).hasClass(`!${id.replace("#","")}`)) $(this).addClass(`!${id.replace("#","")}`);
			if(!$(this).hasClass("!discount")) $(this).addClass("!discount");
			//Checks if it's hidden and hides it if its not
			if(!$(this).hasClass("d-none")) $(this).addClass("d-none");
		}
		if(!isActive){
			//Removes appropriate flags
			if($(this).hasClass(`!${id.replace("#","")}`)) $(this).removeClass(`!${id.replace("#","")}`);
			let otherDiscount:boolean = false;
			for(let x in discounts){
				if($(this).hasClass(`!${discounts[x]}`)) otherDiscount = true;
			}
			//If this doesn't have any other affiliate tags and has the affiliate tag... remove it
			if(!otherDiscount && $(this).hasClass("!discount")){
				$(this).removeClass("!discount")
				//If this class is hidden and is not filtered by anything else, unhide it
				if($(this).hasClass("d-none") && !isFiltered($(this))) $(this).removeClass("d-none");
			}
			//Double check to unhide if it's not filtered
			if($(this).hasClass("d-none") && !isFiltered($(this))) $(this).removeClass("d-none");
		}
	});
	update_aANDa_display();
};

export function filter_by_rvLW(options?: {len_min?: number, len_max?: number, wid_min?: number, wid_max?: number}) {
	//Check if filter_by_rvLW() is called without parameters -> if it is check the campcards and show the ones we need to show
	if (!(options?.len_min || options?.len_max || options?.wid_min || options?.wid_max)) {
		$(".campsite-card").each(function() {
			if ($(this).hasClass("!rvLW")) $(this).removeClass("!rvLW");
			if ($(this).hasClass("d-none") && !isFiltered($(this))) {
				$(this).removeClass("d-none");
			};
		});
		return;
	};
	$(".campsite-card").each(function() {
		if ($(this).attr("unfilterable") != undefined) {
			return;
		};
		//Collect rv data from each card
		let campRVLW:string[] = $(this).find(".campground-rvlw").text().split(",");
		let rvLen = -1;
		let rvWid = -1;
		if(campRVLW[0] != "None"){
			rvLen = parseInt(campRVLW[0]);
		}else{
			//
		}
		if(campRVLW[1] != "None"){
			rvWid = parseInt(campRVLW[1]);
		}else{
			//
		}

		//Checks if there is any len/wid data on the campcard
		if(rvLen == -1 && rvWid == -1){
			//If any options were set -> hide the card w/ no len/wid data
			if ((options?.len_min || options?.len_max || options?.wid_min || options?.wid_max)) {
				if (!$(this).hasClass("!rvLW")) $(this).addClass("!rvLW");
				if (!$(this).hasClass("d-none")) $(this).addClass("d-none");
			} else {
				//ELSE remove cards that were previously? hidden by !rvLW.
				if ($(this).hasClass("!rvLW")) $(this).removeClass("!rvLW");
				//Checks if it's filtered by anything else, if it's not then it will unhide the card.
				if ($(this).hasClass("d-none") && !isFiltered($(this))) {
					$(this).removeClass("d-none");
				};
			};
			return;
		}

		//If user has touched the len_min
		if(options?.len_min){
			//If rvLen (on the card) is less than the inputted minimum -> hide card
			if(rvLen < options?.len_min){
				if (!$(this).hasClass("!rvLW")) $(this).addClass("!rvLW");
				if (!$(this).hasClass("d-none")) $(this).addClass("d-none");
			}else{
			//else -> remove rvLW class and unhide if no one else is filtering it
				$(this).removeClass("!rvLW");
				if ($(this).hasClass("d-none") && !isFiltered($(this))) $(this).removeClass("d-none");
			}
		}
		if(options?.len_max){
			//If rvLen (on the card) is less than the inputted minimum -> hide card
			if(rvLen > options?.len_max){
				if (!$(this).hasClass("!rvLW")) $(this).addClass("!rvLW");
				if (!$(this).hasClass("d-none")) $(this).addClass("d-none");
			}else{
			//else -> remove rvLW class and unhide if no one else is filtering it
				$(this).removeClass("!rvLW");
				if ($(this).hasClass("d-none") && !isFiltered($(this))) $(this).removeClass("d-none");
			}
		}
		if(options?.wid_min){
			//If rvWid (on the card) is less than the inputted minimum -> hide card
			if(rvWid < options?.wid_min){
				if (!$(this).hasClass("!rvLW")) $(this).addClass("!rvLW");
				if (!$(this).hasClass("d-none")) $(this).addClass("d-none");
			}else{
			//else -> remove rvLW class and unhide if no one else is filtering it
				$(this).removeClass("!rvLW");
				if ($(this).hasClass("d-none") && !isFiltered($(this))) $(this).removeClass("d-none");
			}
		}
		if(options?.wid_max){
			//If rvWid (on the card) is less than the inputted minimum -> hide card
			if(rvWid > options?.wid_max){
				if (!$(this).hasClass("!rvLW")) $(this).addClass("!rvLW");
				if (!$(this).hasClass("d-none")) $(this).addClass("d-none");
			}else{
			//else -> remove rvLW class and unhide if no one else is filtering it
				$(this).removeClass("!rvLW");
				if ($(this).hasClass("d-none") && !isFiltered($(this))) $(this).removeClass("d-none");
			}
		}

	});
	update_aANDa_display();
}

export function filter_by_price(options?: {val_min?: number, val_max?: number}) {
	if (!(options?.val_min || options?.val_max)) {
		$(".campsite-card").each(function() {
			if ($(this).hasClass("!price")) $(this).removeClass("!price");
			if ($(this).hasClass("d-none") && !isFiltered($(this))) {
				$(this).removeClass("d-none");
			};
		});
		return;
	};

	$(".campsite-card").each(function() {
		if ($(this).attr("unfilterable") != undefined) {
			return;
		};
		//Collect price data from cards
		let campPrice:string[] = $(this).find(".campgrounds-price").text().split(",");
		let campPriceLow:number = -1;
		let campPriceHigh:number = -1;
		let campPriceBoth:boolean = true;
		let campPriceSolo:number = -1;

		if(campPrice[0] != "None" && campPrice[0] != "?"){
			campPriceLow = parseInt(campPrice[0]);
		}else{
			campPriceBoth = false;
		}
		if(campPrice[1] != "None" && campPrice[1] != "?"){
			campPriceHigh = parseInt(campPrice[1]);
		}else{
			campPriceBoth = false;
		}

		if(!campPriceBoth){
			if(campPriceLow != -1) campPriceSolo = campPriceLow;
			if(campPriceHigh != -1) campPriceSolo = campPriceHigh;
		}

		//Check if camp has price data at all. Both will be -1 if there is no price data.
		if (campPriceLow == -1 && campPriceHigh == -1) {
			//Check if any price options have been set. If either have, hide cards with no price data.
			if (options?.val_min || options?.val_max) {
				if (!$(this).hasClass("!price")) $(this).addClass("!price");
				if (!$(this).hasClass("d-none")) $(this).addClass("d-none");
			} else {
				//ELSE remove cards that were previously? hidden by !price.
				if ($(this).hasClass("!price")) $(this).removeClass("!price");
				//Checks if it's filtered by anything else, if it's not then it will unhide the card.
				if ($(this).hasClass("d-none") && !isFiltered($(this))) {
					$(this).removeClass("d-none");
				};
			};
			return;
		};

		if(options?.val_min && options?.val_max){
			//If price low and high are both values in the card
			if(campPriceBoth){
				//If the low or high is less than the set min -> hide card
				if(options?.val_max < campPriceLow || options?.val_min > campPriceHigh || campPriceHigh == 0 || campPriceLow == 0){
					if (!$(this).hasClass("!price")) $(this).addClass("!price");
					if (!$(this).hasClass("d-none")) $(this).addClass("d-none");
				}else{
					$(this).removeClass("!price");
					if ($(this).hasClass("d-none") && !isFiltered($(this))) $(this).removeClass("d-none");
				}
			}else{
			//else if only one of price low and high are set
				//If the low or high is less than the set min -> hide card
				if(campPriceSolo < options?.val_min || campPriceSolo > options?.val_max){
					if (!$(this).hasClass("!price")) $(this).addClass("!price");
					if (!$(this).hasClass("d-none")) $(this).addClass("d-none");
				}else{
					$(this).removeClass("!price");
					if ($(this).hasClass("d-none") && !isFiltered($(this))) $(this).removeClass("d-none");
				}
			}
		}else{
			if(options?.val_min){
				//If price low and high are both values in the card
				if(campPriceBoth){
					//If the low or high is less than the set min -> hide card
					if(campPriceHigh < options?.val_min || campPriceHigh == 0 || campPriceLow == 0){
						if (!$(this).hasClass("!price")) $(this).addClass("!price");
						if (!$(this).hasClass("d-none")) $(this).addClass("d-none");
					}else{
						$(this).removeClass("!price");
						if ($(this).hasClass("d-none") && !isFiltered($(this))) $(this).removeClass("d-none");
					}
				}else{
				//else if only one of price low and high are set
					//If the low or high is less than the set min -> hide card
					if(campPriceSolo < options?.val_min){
						if (!$(this).hasClass("!price")) $(this).addClass("!price");
						if (!$(this).hasClass("d-none")) $(this).addClass("d-none");
					}else{
						$(this).removeClass("!price");
						if ($(this).hasClass("d-none") && !isFiltered($(this))) $(this).removeClass("d-none");
					}
				}
			}

			if(options?.val_max){
				//If price low and high are both values in the card
				if(campPriceBoth){
					//If the low price of the camp is more than the set max... hide the card ELSE show the card
					if(!(options?.val_max >= campPriceLow) || campPriceHigh == 0 || campPriceLow == 0){
						if (!$(this).hasClass("!price")) $(this).addClass("!price");
						if (!$(this).hasClass("d-none")) $(this).addClass("d-none");
					}else{
						$(this).removeClass("!price");
						if ($(this).hasClass("d-none") && !isFiltered($(this))) $(this).removeClass("d-none");
					}
				}else{
				//else if only one of price low and high are set
					//If the low or high is more than the set min -> hide card
					if(campPriceSolo > options?.val_max){
						if (!$(this).hasClass("!price")) $(this).addClass("!price");
						if (!$(this).hasClass("d-none")) $(this).addClass("d-none");
					}else{
						$(this).removeClass("!price");
						if ($(this).hasClass("d-none") && !isFiltered($(this))) $(this).removeClass("d-none");
					}
				}
			}
		}


	});
	update_aANDa_display();
}

export function filter_by_sites(options?: {but?: string, active?: boolean}): void{
	let small:boolean = $("#filterSmallCamp").hasClass("active") || (options?.but == "small" && options?.active);
	if((options?.but == "small" && !options?.active)) small = false;
	let medium:boolean = $("#filterMediumCamp").hasClass("active") || (options?.but == "medium" && options?.active);
	if((options?.but == "medium" && !options?.active)) medium = false;
	let large:boolean = $("#filterLargeCamp").hasClass("active") || (options?.but == "large" && options?.active);
	if((options?.but == "large" && !options?.active)) large = false;

	if (small && medium && large) {
    filter_by_sites_OLD({val_min:0, val_max:1500});
  } else if (small && medium) {
    filter_by_sites_OLD({val_min:0, val_max:150});
  } else if (small && large) {
		filter_by_sites_OLD({val_min:0, val_max:50, val_min2:150, val_max2: 1500});
  } else if (medium && large) {
    filter_by_sites_OLD({val_min:50, val_max:1500});
  } else if (small) {
    filter_by_sites_OLD({val_min:0, val_max:50});
  } else if (medium) {
    filter_by_sites_OLD({val_min:50, val_max:150});
  } else if (large) {
    filter_by_sites_OLD({val_min:150, val_max:1500});
  } else {
    filter_by_sites_OLD();
  }
	update_aANDa_display();
};

export function filter_instantBook_campsTP(activeFilter:boolean) {
	$('.campsite-card').each(function () {
		if ($(this).attr("unfilterable") != undefined) {
			return;
		};
		if ($(this).find("> * > img#s2n-logo").length === 0) {
			if (activeFilter) {
				$(this).addClass("!instantBook")
				$(this).addClass("d-none");
			} else {
				if ($(this).hasClass("!instantBook")) $(this).removeClass("!instantBook");
				if ($(this).hasClass("d-none") && !isFiltered($(this))) {
					$(this).removeClass("d-none");
				};
			};
		};
	});

	update_aANDa_display();
};

export function filter_by_sites_OLD(options?: {val_min?: number, val_max?: number, val_min2?: number, val_max2?: number}) {
	if(options?.val_min2 != null && options?.val_max2 != null){
		$(".campsite-card").each(function() {
			if ($(this).attr("unfilterable") != undefined) {
				return;
			};
			if ($(this).find(".campground-sites").text() == "None" || $(this).find(".campground-sites").text() == "0") {
				if (options?.val_min || options?.val_max) {
					if (!$(this).hasClass("!sites")) $(this).addClass("!sites");
					if (!$(this).hasClass("d-none")) $(this).addClass("d-none");
				} else {
					if ($(this).hasClass("!sites")) $(this).removeClass("!sites");
					if ($(this).hasClass("d-none") && !isFiltered($(this))) {
						$(this).removeClass("d-none");
					};
				};
				return;
			};
			let site_str:string = $(this).find(".campground-sites").text();
			if (site_str == undefined) return;
			let sites:number = parseInt(site_str);
			if(options?.val_min2 != null && options?.val_max2 != null && options?.val_min != null && options?.val_max !=null ){
				if((sites >= options?.val_min && sites <= options?.val_max) || (sites >= options?.val_min2 && sites <= options?.val_max2)){
					if ($(this).hasClass("!sites")) $(this).removeClass("!sites");
					if ($(this).hasClass("d-none") && !isFiltered($(this))) {
						$(this).removeClass("d-none");
					};
				}else{
					if (!$(this).hasClass("!sites")) $(this).addClass("!sites");
					if (!$(this).hasClass("d-none")) $(this).addClass("d-none");
				}
			}
		});
	}else{
		if (!(options?.val_min || options?.val_max)) {
			$(".campsite-card").each(function() {
				if ($(this).hasClass("!sites")) $(this).removeClass("!sites");
				if ($(this).hasClass("d-none") && !isFiltered($(this))) {
					$(this).removeClass("d-none");
				};
			});
			return;
		};
		$(".campsite-card").each(function() {
			if ($(this).find(".campground-sites").text() == "None" || $(this).find(".campground-sites").text() == "0") {
				if (options?.val_min || options?.val_max) {
					if (!$(this).hasClass("!sites")) $(this).addClass("!sites");
					if (!$(this).hasClass("d-none")) $(this).addClass("d-none");
				} else {
					if ($(this).hasClass("!sites")) $(this).removeClass("!sites");
					if ($(this).hasClass("d-none") && !isFiltered($(this))) {
						$(this).removeClass("d-none");
					};
				};
				return;
			};
			let site_str:string = $(this).find(".campground-sites").text();
			if (site_str == undefined) return;
			let sites:number = parseInt(site_str);

			let hidden:boolean = false;
			if(options?.val_min){
				if (sites < options?.val_min) {
					$(this).addClass("!sites");
					if (!$(this).hasClass("d-none")){
						$(this).addClass("d-none");
					}
					hidden = true;
				} else if ($(this).hasClass("!sites")) {
					$(this).removeClass("!sites");
					if ($(this).hasClass("d-none") && !isFiltered($(this))) $(this).removeClass("d-none");
				};
			}

			if(options?.val_max && !hidden){
				if (sites > options?.val_max) {
					$(this).addClass("!sites");
					if (!$(this).hasClass("d-none")) $(this).addClass("d-none");
				} else if ($(this).hasClass("!sites")) {
					$(this).removeClass("!sites");
					if ($(this).hasClass("d-none") && !isFiltered($(this))) $(this).removeClass("d-none");
				};
			}
		});
	}
	update_aANDa_display();
};

export function getNumActiveFilters() {
	return ($(".amenityToggleButton.active").length +
					$(".activityToggleButton.active").length +
					(($("#rvL_min").val().toString().length > 0) ? 1:0) +
					(($("#price_max").val().toString().length > 0) ? 1:0) +
					(($("#filterSmallCamp").hasClass("active")) ? 1:0) +
					(($("#filterMediumCamp").hasClass("active")) ? 1:0) +
					(($("#filterLargeCamp").hasClass("active")) ? 1:0) +
					(($("#instantBook").hasClass("active")) ? 1:0));
};